import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WorkflowWidget, WorkflowAllowedActions } from '../models';

@Injectable({
    providedIn: 'root'
})
export class WorkflowService {
    private readonly apiUrl = 'api/workflow';

    constructor(private readonly httpClient: HttpClient) { }

    getWorkflowWidget(): Observable<WorkflowWidget> {
        return this.httpClient.get<WorkflowWidget>(`${this.apiUrl}/Widget`);
    }

    getRoutingHistory(packageId: number): Observable<string> {
        return this.httpClient.get<string>(`${this.apiUrl}/${packageId}/RoutingHistory`);
    }

    getAllowedActions(packageId: number): Observable<WorkflowAllowedActions> {
        return this.httpClient.get<WorkflowAllowedActions>(`${this.apiUrl}/${packageId}/AllowedActions`);
    }
}